<template>
  <div class="document-container">
    <div class="columns is-desktop">
      <div
        v-if="hasModule('PRSID:IDENT:DUPLICATES:VIEW')"
        class="column"
      >
        <duplicate-ids/>
      </div>
      <div
        v-if="hasModule('PRSID:IDENT:SHAREDIDS:VIEW')"
        class="column"
      >
        <shared-ids/>
      </div>
      <div class="column">
        <identifier-summary/>
      </div>
    </div>
  </div>
</template>

<script>
import DuplicateIds from '@/components/ID Manager Components/DuplicateIds.vue';
import IdentifierSummary from '@/components/ID Manager Components/IdentifierSummary.vue';
import SharedIds from '@/components/ID Manager Components/SharedIds.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    DuplicateIds,
    IdentifierSummary,
    SharedIds,
  },
};
</script>

<style lang="sass" scoped>
  .column
    padding: 0.5rem !important
    display: flex
</style>
